
export const getLanguage = (lang: string) =>
  lang.replace(/-[A-Z]+/, '')
